import {
  useGetFolderQuery,
  useGetWorkspaceQuery,
  useRestoreFolderMutation,
} from '@carboncopyco/data';
import { RevertOutlineIcon } from '@carboncopyco/icons';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { Button, notify } from '@carboncopyco/ui';
import { useFolderAnalytics } from '@carboncopyco/utils';
import { useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePermissionsContext } from '../../../../utils';
import { useWorkspacePageProps } from '../../WorkspacePageContext';
import { WorkspacePageHeader } from '../../WorkspacePageHeader';
import { FolderPageHeader } from '../FolderPageHeader';
import { FolderPageBodyArchived } from './FolderPageBodyArchived';

export const FolderPageArchived = () => {
  const { folderId } = useParams();
  const { organizationId, workspaceId, rootPath } = useWorkspacePageProps();
  const { getPermissions } = usePermissionsContext();
  const navigate = useNavigate();
  const restoreButtonRef = useRef<HTMLDivElement>(null);
  const [restoreFolder] = useRestoreFolderMutation();
  const { trackFolderClickRestore } = useFolderAnalytics('folder_archive');
  const { data: folder } = useGetFolderQuery({
    organizationId,
    workspaceId,
    folderId,
    removeDeleted: false,
  });
  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });

  const restoreFolderPermission = getPermissions(
    PermissionKey.folder,
    PermissionAction.restoreAFolder
  );

  return (
    <>
      <WorkspacePageHeader>
        <div className="flex flex-col w-10/12">
          <FolderPageHeader
            folder={folder}
            archived
          />
        </div>
        {restoreFolderPermission && (
          <div ref={restoreButtonRef}>
            <Button
              label="Restore folder"
              leftIcon={<RevertOutlineIcon />}
              link
              blue
              onClick={() => {
                trackFolderClickRestore({
                  workspaceId,
                  folderId: folder.id,
                  workspaceName: workspace?.workspaceName,
                  workspaceType: workspace?.workspaceType,
                });
                restoreFolder({
                  organizationId,
                  folderId: folder.id,
                  workspaceId,
                })
                  .unwrap()
                  .then(() => {
                    navigate(`${rootPath}/archive`);
                    notify.success('Folder was restored successfully.');
                  })
                  .catch(() =>
                    notify.error(
                      'Unable to restore the folder. Please try again.'
                    )
                  );
              }}
            />
          </div>
        )}
      </WorkspacePageHeader>
      <FolderPageBodyArchived />
    </>
  );
};
